import React from 'react'
import { Box } from '@mui/material'

import { isAnalyzerLoading } from 'Pages/AnalyzersV2/@signals'
import { AppValueChip } from '@components'
import { dsColorNew } from '@palette'

const formatDate = date => {
	const raw = String(date)
	return `${raw.slice(6, 8)}/${raw.slice(4, 6)}/${raw.slice(0, 4)}`
}

const buildWindow = (columns = []) => {
	const dates = columns.filter(Boolean)

	if (!dates.length) return null
	if (dates.length === 1) return formatDate(dates[0])

	return `${formatDate(dates[0])} – ${formatDate(dates[dates.length - 1])}`
}

/**
 * Context the filter bar does not already state: which brand everything is
 * measured against, the pickup window covered and how many rivals are tracked.
 */
export default function PositionContext({ mainName, office, columns, totalBrands, currency }) {
	if (isAnalyzerLoading.value) return null

	const window = buildWindow(columns)
	const competitors = totalBrands > 1 ? totalBrands - 1 : null

	const chips = [
		{ key: 'office', label: 'Office', value: office?.name },
		{ key: 'window', label: 'Window', value: window },
		{ key: 'competitors', label: 'Competitors', value: competitors ? `${competitors} tracked` : null },
		{ key: 'currency', label: 'Currency', value: currency },
	].filter(({ value }) => !!value)

	if (!mainName && !chips.length) return null

	// The brand in the app blue, the rest as the app's soft value chips: a muted label and the value
	return <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
		{!!mainName && <AppValueChip tone="accent" sx={{ fontSize: 13, py: 0.5 }}>
			<Box component="span" sx={{ color: dsColorNew.textMuted }}>Brand</Box>
			<Box component="span" sx={{ fontWeight: 700 }}>{mainName}</Box>
		</AppValueChip>}

		{chips.map(({ key, label, value }) => <AppValueChip key={key} sx={{ fontSize: 13, py: 0.5 }}>
			<Box component="span" sx={{ color: dsColorNew.textMuted }}>{label}</Box>
			<Box component="span" sx={{ fontWeight: 700, color: dsColorNew.textTitle }}>{value}</Box>
		</AppValueChip>)}
	</Box>
}
